import COMMON from "./common";
import PAGES from "./pages";
import EXPORT from "./exports";
import FILTERS from "./filters";
import VIEWS from "./views";

const ICONS: Record<string, Record<string, string>> = {
  ...PAGES,
  ...COMMON,
  ...EXPORT,
  ...FILTERS,
  VIEWS: VIEWS,
};

export default ICONS;
